module.exports = __webpack_public_path__ + "media/images/vanguard-lg-3b74512d63295fa29c5941900cbaf8dd.png";